import { REQUEST_DIALOG_SUCCESS } from '../../actions';

export function modifyGraphFormat({ dispatch }) {
  return function (next) {
    return function (action) {
      // if (action.type === REQUEST_DIALOG_SUCCESS) {
      //   console.log('REQUEST_DIALOG_SUCCESS triggered');
      // }
      return next(action);
    };
  };
}
